var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Watch } from 'vue-property-decorator';
import { getVideosCRM } from '@/shared/utils/Infosets.utils';
import { NotificationService } from '@/services/NotificationService';
import { verifyRdStationToken } from '@/clients/crm';
import Modal from 'components/Modal.vue';
import Tooltip from 'components/Tooltip.vue';
import CrmCardContent from 'components/CrmCardContent.vue';
let RdSTationConfigCard = class RdSTationConfigCard extends Vue {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.token = '';
        this.tokenVerified = false;
        this.ocultedToken = true;
        this.openModal = false;
        this.crmIcon = 'statics/images/logos/rdstation-logo.svg';
        this.companyFields = [
            'Razão Social',
            'CNPJ',
            'Nome Fantasia',
            'Natureza Jurídica',
            'Setor',
            'Website',
            'Faixa de Faturamento da Unidade CNPJ',
            'Faixa de Funcionários da Unidade CNPJ',
            'Data de Abertura',
            'Situação do CNPJ',
            'Endereço',
            'Todos os Telefones',
            'Todos os Emails',
            'Nome do Administrador',
            'Decisores',
            'Emails Principais',
            'Telefones Principais',
            'Origem',
        ];
        this.decisorFields = [
            'Nome',
            'Empresa',
            'Nível de decisão',
            'E-mail',
            'Link do linkedIn',
        ];
        this.questions = [
            {
                question: 'Quais planos permitem exportação?',
                answer: 'Basic ou Pro.',
            },
            {
                question: 'Onde ficam os dados das empresas?',
                answer: 'No menu superior em "Empresas".',
            },
            {
                question: 'Onde ficam os dados de decisores?',
                answer: 'No menu superior em "Contatos"',
            },
            {
                question: 'O que acontece se eu exportar 2 vezes a mesma empresa?',
                answer: 'Nosso integrador irá detectar que já existe uma empresa cadastrada e não enviará novamente',
            },
        ];
        this.observations = [
            'A conta deve ser criada no RD Station CRM, contas criadas em RD Station Marketing não conseguem realizar integração.',
        ];
    }
    changedOpenModal() {
        this.ocultedToken = true;
    }
    get tutorialVideoLink() {
        return getVideosCRM('rdstation');
    }
    async verifyToken() {
        this.loading = true;
        try {
            await verifyRdStationToken({ token: this.token });
            this.tokenVerified = true;
            this.ocultedToken = true;
            NotificationService.success('Sucesso', 'Seu token do RD Station foi salvo com sucesso. Agora você pode exportar para o RD Station!');
        }
        catch (e) {
            NotificationService.error('Error', 'O token selecionado está inválido');
        }
        this.loading = false;
    }
    changeToken() {
        this.token = '';
        this.tokenVerified = false;
    }
};
__decorate([
    Watch('openModal')
], RdSTationConfigCard.prototype, "changedOpenModal", null);
RdSTationConfigCard = __decorate([
    Component({
        name: 'RdSTationConfigCard',
        components: {
            Modal,
            Tooltip,
            CrmCardContent,
        },
    })
], RdSTationConfigCard);
export default RdSTationConfigCard;
